<template>
  <header>
    <div
      :class="{ 'header--restaurant-index': isRestaurantIndex }"
      class="header"
    >
      <div
        :class="{ 'header__body--restaurant-index': isRestaurantIndex }"
        class="header__body"
      >
        <h2 class="header__restaurant-name">
          <a :href="indexUrl" class="header__restaurant-index-link">{{ name }}</a>
        </h2>
        <restaurant-header-menu
          :links="links"
          class="header__menus"/>
        <restaurant-thumbnail
          :link="settingLogoUrl"
          :src="thumbnail"
          class="header__icon"/>
      </div>
      <nav
        v-if="isRestaurantIndex"
        :restaurant-id="restaurantId"
        class="header__page-navs"
      >
        <restaurant-index-header-link-list
          :restaurant-id="restaurantId"
          :is-free-member="isFreeMember"
        />
      </nav>
    </div>
  </header>
</template>

<script>
import { VTRestaurantId } from '@/mikan/_shared/types/vueTypes/restaurant';
import { buildSettingLogoUrl, buildRestaurantIndexUrl } from '@/mikan/_shared/lib/urlBuilders';
import RestaurantHeaderMenu from '@/mikan/pc/components/organisms/RestaurantHeaderMenu.vue';
import RestaurantThumbnail from '@/mikan/_shared/components/atoms/RestaurantThumbnail.vue';
import RestaurantIndexHeaderLinkList from '@/mikan/_shared/components/organisms/RestaurantIndex/RestaurantIndexHeaderLinkList.vue';

export default {
  components: {
    RestaurantHeaderMenu,
    RestaurantThumbnail,
    RestaurantIndexHeaderLinkList,
  },
  props: {
    name: {
      type: String,
      default: '',
    },
    thumbnail: {
      type: String,
      default: '',
    },
    links: {
      type: Array,
      default: () => [],
    },
    isRestaurantIndex: {
      type: Boolean,
      default: false,
    },
    restaurantId: VTRestaurantId.def(''),
    isFreeMember: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    settingLogoUrl() {
      return buildSettingLogoUrl(this.restaurantId);
    },
    indexUrl() {
      return this.restaurantId ? buildRestaurantIndexUrl(this.restaurantId) : '';
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/mikan/pc/base/constants';

.header {
  display: flex;
  overflow: hidden;
  flex-direction: column;
  align-items: center;
  padding-top: 6px;
  margin-top: -6px;
  background-image: $gradient-orange;
  background-repeat: no-repeat;
  background-size: 100% 35px;

  &--restaurant-index {
    padding-bottom: 24px;
    background-color: $color-navy-05;
    box-shadow: 0 -6px 6px -4px rgba(0, 0, 0, 0.1) inset;
  }

  &__body {
    display: flex;
    width: $full-width;
    align-items: center;
    justify-content: space-between;
    padding: 20px 30px;
    background-color: $color-white;
    border-radius: 4px 4px 0 0;
    box-shadow: 0 -3px 6px 0 rgba(0, 0, 0, 0.04), 12px -10px 8px -12px rgba(0, 0, 0, 0.06),
      -12px -10px 8px -12px rgba(0, 0, 0, 0.06);
    font-size: $size-ll;

    &--restaurant-index {
      background-image: linear-gradient(to bottom, $color-white 60%, $color-navy-05);
    }
  }

  &__restaurant-name {
    overflow: hidden;
    flex-grow: 1;
    font-weight: bold;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  &__restaurant-index-link {
    color: inherit;
  }

  &__menus {
    flex-shrink: 0;

    &:nth-child(n + 2) {
      margin-left: 32px;
    }
  }

  &__icon {
    width: 30px;
    height: 30px;

    &:nth-child(n + 2) {
      margin-left: 32px;
    }
  }

  &__page-navs {
    width: $full-width;

    &:nth-child(n + 2) {
      margin-top: 12px;
    }
  }
}
</style>
